import { css } from '@styled-system/css';
import { token } from '@styled-system/tokens';
import type { SystemProperties } from '@styled-system/types';
import type { ReactNode } from 'react';

interface TagProps {
  children: ReactNode;
  color?: SystemProperties['color'];
  className?: string;
}

export const Tag = ({ children, color, className }: TagProps) => {
  // Résoudre la couleur du token Panda CSS en valeur CSS réelle
  const resolvedColor = color
    ? typeof color === 'string' && color.includes('.')
      ? token.var(`colors.${color}` as any)
      : color
    : token.var('colors.accent.orange'); // Couleur par défaut

  const tagStyles = css({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    px: '0.41667rem', // Padding spécifique du design
    py: '0.2rem',

    // Background avec opacité comme dans le design
    bg: 'transparent',
    rounded: 'xl', // radii-xl (99px) border radius pour forme pill

    // Typography du design Figma
    fontSize: '2xs', // font-2xs (10px)
    fontWeight: 'semibold', // Manrope SemiBold
    fontFamily: 'Manrope, sans-serif',
    color: color ?? 'accent.orange', // Couleur du texte
    textAlign: 'center',
    whiteSpace: 'nowrap',
    lineHeight: 1.4, // Line height du design

    // Overflow pour les textes longs
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  });

  // Créer le background avec opacité basé sur la couleur
  const backgroundStyle = resolvedColor
    ? { backgroundColor: `color-mix(in srgb, ${resolvedColor} 10%, transparent)` }
    : { backgroundColor: 'rgba(255, 168, 82, 0.1)' };

  return (
    <div className={`${tagStyles} ${className || ''}`} style={backgroundStyle}>
      {children}
    </div>
  );
};
